module.exports = __webpack_public_path__ + "files/99e2cd753e0a95ffd99a40f64ca69143.png";